import block from 'bem-cn-lite';
import {Modal, Text, Button} from '@gravity-ui/uikit';
import {KeyboardCloseButton} from '@components/KeyboardNavigation';

import './ModalQuit.scss';

const b = block('modal-quit');

interface ModalQuitProps {
    visibility: boolean;
    stateModal: (value: boolean) => void;
    positiveAction: () => void;
}

export const ModalQuit: React.FC<ModalQuitProps> = ({visibility, stateModal, positiveAction}) => {
    return (
        <Modal open={visibility} className={b('modal')} onClose={() => stateModal(false)}>
            <Text className={b('header')} variant="subheader-3">
                Выйти из профиля?
                <KeyboardCloseButton onClose={() => stateModal(false)} />
            </Text>
            <Button className="modal-btn" size="m" view="flat" onClick={() => stateModal(false)}>
                Отмена
            </Button>
            <Button
                className="modal-btn"
                size="m"
                view="flat"
                onClick={() => {
                    positiveAction();
                }}
            >
                Выйти
            </Button>
        </Modal>
    );
};
